var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('article',[_c('h1',{staticClass:"center"},[_vm._v("金融借贷相关公司说明")]),_c('section',[_c('p',[_vm._v("产品名称：诚星借")]),_c('p',[_vm._v("主体公司：重庆小米消费金融有限公司")])])])])
}]

export { render, staticRenderFns }